export default __webpack_public_path__ + "static/media/ProfileManagement.dc3739a3.svg";